
















































































































import { computed, defineComponent, PropType, ref } from '@vue/composition-api';
import { useFetchPaymentPlans } from '@/composable/payment-plan';
import { IPaymentPlan, IQuote } from '@/models';
import { IFetchPaymentPlansParams } from '@/services';
import { dateFromNow } from '@/utils/dateHelpers';
import ErrorAlert from '../common/ErrorAlert.vue';
import PaymentPlanStatusDisplay from './PaymentPlanStatusDisplay.vue';

export default defineComponent({
  name: 'RevisionHistoryBanner',
  components: { ErrorAlert, PaymentPlanStatusDisplay },

  props: {
    paymentPlan: {
      type: Object as PropType<IPaymentPlan>,
      required: true
    }
  },

  setup(props, { root }) {
    const showHistory = ref(false);

    const currentPaymentPlan = computed(() => props.paymentPlan);

    const filterParams = computed<IFetchPaymentPlansParams>(() => ({
      quote__number: (currentPaymentPlan.value.quote as IQuote).number
    }));

    const {
      paymentPlans: revisionPlans,
      error,
      isLoading: isFetchLoading
    } = useFetchPaymentPlans(filterParams.value);

    function clearAllErrors() {
      error.value = null;
    }

    function goToPaymentPlan(id: number) {
      // Redirect to payment plan detail page
      root.$router.push({
        name: 'payment-plan-detail',
        params: { id: id.toString() }
      });
    }

    return {
      showHistory,
      revisionPlans,
      error,
      isFetchLoading,
      dateFromNow,
      goToPaymentPlan,
      clearAllErrors
    };
  }
});
